import { Wrapper } from 'src/components/Wrapper';
import { useWindowWidth } from 'src/hooks/useWindowWidth';
import { type Breadcrumb, Breadcrumbs } from 'src/uikit/Breadcrumbs';

import s from './MarketplaceHero.module.scss';

export type HeroProps = {
  title: string;
  description: string;
  breadcrumbs: Breadcrumb[];
  image: string;
};

export function MarketplaceHero({
  title,
  description,
  breadcrumbs = [],
  image,
}: HeroProps) {
  const {
    windowWidth,
    breakpoints: { MD, SM },
  } = useWindowWidth();

  return (
    <section className={s.root} data-qa="MKPHero-block">
      <Wrapper className={s.wrapper}>
        <Breadcrumbs links={breadcrumbs} />

        <div className={s.contentWrapper}>
          <div className={s.content}>
            <div className={s.info}>
              <div className={s.text}>
                <h1 className={s.title}>{title}</h1>
                <div className={s.description}>{description}</div>
              </div>
            </div>

            {windowWidth && windowWidth <= MD && windowWidth > SM && (
              <div className={s.imageWrapper}>
                <img
                  className={s.image}
                  width={300}
                  height={300}
                  src={image}
                  alt="Marketplace image"
                  data-qa="marketplace-image"
                />
              </div>
            )}
          </div>

          {windowWidth && windowWidth > MD && (
            <div className={s.imageWrapper}>
              <img
                className={s.image}
                width={300}
                height={300}
                src={image}
                alt="Marketplace image"
                data-qa="marketplace-image"
              />
            </div>
          )}

          {windowWidth && windowWidth <= SM && (
            <div className={s.imageWrapper}>
              <img
                className={s.image}
                width={300}
                height={300}
                src={image}
                alt="Marketplace image"
                data-qa="marketplace-image"
              />
            </div>
          )}
        </div>
      </Wrapper>
    </section>
  );
}
